import moment  from 'moment';
import { HOME_INSIGHTS_DATA_FEEDTYPE } from '../constants/common';

export const createDummyDataHomeInsights = (translations) => {
    let dummyData = [];
    let date = new Date();
    for (let i = 0; i < 3; i++) {
      dummyData[i] = {};
      dummyData[i].feedType = HOME_INSIGHTS_DATA_FEEDTYPE[Math.floor(Math.random() * HOME_INSIGHTS_DATA_FEEDTYPE.length)];
      dummyData[i].title = translations.title;
      dummyData[i].description = translations.description;
      date = getPreviousMonth(date);
      dummyData[i].computedDateTimeString = date.format('MMM DD, YYYY');
    }
    return dummyData;
  }
  
  export const createDummyDataHomeItemizationWidget = (translations) => {
    let date = new Date();
    let endDate = getPreviousMonth(date);
    let startDate = getPreviousMonth(endDate);
    return {
      itemizationDisclaimer: translations.disclaimer,
      itemizationDetails: {
        startDate: startDate.format('MMM DD, YYYY'),
        endDate: endDate.format('MMM DD, YYYY')
      }
    }
  }
  
  export const createDummyDataHomeItemizationXAxis = () => {
    let dates = [], currentDay = new Date();
    for (let i = 0; i < 13; i++) {
      currentDay = getPreviousMonth(currentDay);
      dates.push(currentDay.format('MMM DD'));
    }
    dates.reverse();
    return dates;
  }
  
  export const getPreviousMonth = (month) => {
    return moment(month).subtract(1, 'months');
  }